import React from "react";
import Footer from "../components/Footer";
import SharedNavbar from "../components/SharedNavbar";
import "../App.css"; // Global styles
import "./SecurityPage.css"; // Reuse Security Page styles for premium look
import PrivacyPolicy from "./PrivacyPolicy";

const PrivacyPage = () => {

  return (
    <div className="security-page">
      {/* Navigation - Identical to SecurityPage */}
      <SharedNavbar />

      {/* Main Content */}
      <div style={{ paddingTop: "2rem" }}>
        <PrivacyPolicy />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPage;
